if (!customElements.get('code-product-quantity-selector')) {
customElements.define(
  'code-product-quantity-selector',
  class ProductQuantitySelector extends HTMLElement {
    connectedCallback() {
      const {
        input: [input],
        plusButton: [plusButton],
        minusButton: [minusButton],
        value: [value],
      } = codeGetTargets(this);

      let updateTimer = null;
      const debounceDelay = 300; // milliseconds

      value.addEventListener('click', (e) => {
        e.preventDefault();

        publish('updateProductQuantityInputVisibility', {
          variantId: parseInt(this.dataset.variantId),
        });
      });

      [minusButton, plusButton].forEach((button) =>
        button.addEventListener('click', (e) => {
          e.preventDefault();

          const previousValue = input.value;

          switch (button) {
            case plusButton:
              input.stepUp();
              input.dataset.direction = 1;
              break;
            case minusButton:
              input.stepDown();
              input.dataset.direction = -1;
              break;
          }

          if (previousValue !== input.value) {
            // Immediately update the displayed value
            value.innerText = input.value;

            // Update button states immediately
            if (input.min) minusButton.toggleAttribute('disabled', parseInt(input.value) <= parseInt(input.min));
            if (input.max) plusButton.toggleAttribute('disabled', parseInt(input.value) >= parseInt(input.max));

            // Clear any pending update timer
            if (updateTimer) clearTimeout(updateTimer);

            // Set a new timer to trigger the cart update after user stops clicking
            updateTimer = setTimeout(() => {
              // Trigger form change event only after debounce
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }, debounceDelay);
          }
        }),
      );

      input.addEventListener('change', () => {
        // Visual updates already handled in click event
        // This only handles the cart update publication

        publish('updateQuantity', {
          variantId: parseInt(this.dataset.variantId),
          quantity: parseInt(input.value),
          direction: input.dataset.direction,
        });
      });

      this.subscribeCartUpdate = subscribe('cartUpdate', (cart) => {
        if (cart.items.find((item) => item.variant_id === parseInt(this.dataset.variantId))) {
          input.value = cart.items.find((item) => item.variant_id === parseInt(this.dataset.variantId)).quantity;
          value.innerText = input.value;

          if (input.min) minusButton.toggleAttribute('disabled', parseInt(input.value) <= parseInt(input.min));
          if (input.max) plusButton.toggleAttribute('disabled', parseInt(input.value) >= parseInt(input.max));
        }
      });
    }

    disconnectedCallback() {
      this.subscribeCartUpdate();
    }
  },
  );
}
